/**
 * Every non-2xx response from the API has this shape. The console switches on
 * `code`, never on the message text, so error copy can be reworded without
 * breaking client behaviour.
 */
export interface ApiErrorBody {
  code: ApiErrorCode;
  message: string;
  /** Correlates with the audit log and server logs when a user reports a problem. */
  traceId: string;
  details?: unknown;
}

export const API_ERROR_CODES = [
  'UNAUTHENTICATED',
  'SESSION_EXPIRED',
  'FORBIDDEN',
  'SSO_INVALID_TOKEN',
  'SSO_TOKEN_REPLAYED',
  'SSO_TOKEN_EXPIRED',
  'SSO_UNKNOWN_ISSUER',
  'USER_SUSPENDED',
  'POLICY_DENIED',
  'QUERY_LIMIT_EXCEEDED',
  'QUERY_TIMEOUT',
  'QUERY_CANCELLED',
  'DATASOURCE_UNAVAILABLE',
  'VALIDATION_FAILED',
  'NOT_FOUND',
  'CONFLICT',
  'RATE_LIMITED',
  'AUDIT_UNAVAILABLE',
  'INTERNAL',
] as const;
export type ApiErrorCode = (typeof API_ERROR_CODES)[number];

/** Codes for which the console should bounce the user back to the portal. */
export const REAUTH_ERROR_CODES: ReadonlySet<ApiErrorCode> = new Set([
  'UNAUTHENTICATED',
  'SESSION_EXPIRED',
]);
